import { render, staticRenderFns } from "./Estoque.vue?vue&type=template&id=83f222ae&scoped=true"
import script from "./Estoque.vue?vue&type=script&lang=js"
export * from "./Estoque.vue?vue&type=script&lang=js"
import style0 from "./Estoque.vue?vue&type=style&index=0&id=83f222ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f222ae",
  null
  
)

export default component.exports